import type { InterviewPanelView } from '@nest-recruit/shared';

/** Job-contact.dc.html "planner": three people fit a cell; the rest become "+N". */
export const PANEL_PILLS_SHOWN = 3;

export interface PanelPillsLayout {
  readonly shown: readonly InterviewPanelView[];
  /** How many more are on the panel than the pills show. */
  readonly more: number;
}

/** The lead first (wherever they sit on the panel), then the others in the panel's order. */
export function panelPills(panel: readonly InterviewPanelView[], max: number = PANEL_PILLS_SHOWN): PanelPillsLayout {
  const ordered = [...panel.filter((member) => member.role === 'lead'), ...panel.filter((member) => member.role !== 'lead')];
  const shown = ordered.slice(0, max);
  return { shown, more: ordered.length - shown.length };
}
